import { registerMutation, registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { DateTimeDuration } from '../db/DateTimeDuration.js';
import { EvaluationTermin } from '../db/EvaluationTermin.js';
import {
  cancelTerminResolver,
  getMyTerminsResolver,
  getOtherInspectorNameForTerminResolver,
  runTerminSchedulerResolver,
  subscribeMyTerminsResolver,
  subscribeMyTerminsStartingFromResolver,
  subscribeTerminsBySlotIDsResolver,
} from '../server/resolver.js';

export const cancelTermin = registerMutation({
  operationName: 'cancelTermin',
  resolve: cancelTerminResolver,
  type: () => String,
  params: [{ name: 'terminID', type: () => String }],
});

export const getOtherInspectorNameForTermin = registerQuery({
  operationName: 'getOtherInspectorNameForTermin',
  resolve: getOtherInspectorNameForTerminResolver,
  type: () => String,
  params: [{ name: 'terminID', type: () => String }],
});

export const subscribeMyTerminsStartingFrom = registerSubscription({
  operationName: 'subscribeMyTerminsStartingFrom',
  resolve: subscribeMyTerminsStartingFromResolver,
  type: () => [EvaluationTermin],
  params: [{ name: 'terminID', type: () => String }],
});

export const subscribeMyTermins = registerSubscription({
  operationName: 'subscribeMyTermins',
  resolve: subscribeMyTerminsResolver,
  type: () => [EvaluationTermin],
  params: [],
});

export const getMyTermins = registerQuery({
  operationName: 'getMyTermins',
  resolve: getMyTerminsResolver,
  type: () => [EvaluationTermin],
  params: [
    { name: 'userIDs', type: () => [String] },
    { name: 'durationOverlap', type: () => DateTimeDuration },
  ],
});

export const subscribeTerminsBySlotIDs = registerSubscription({
  operationName: 'subscribeTerminsBySlotIDs',
  resolve: subscribeTerminsBySlotIDsResolver,
  type: () => [EvaluationTermin],
  params: [{ name: 'slotIDs', type: () => [String] }],
});

export const runTerminScheduler = registerMutation({
  operationName: 'runTerminScheduler',
  resolve: runTerminSchedulerResolver,
  type: () => String,
  params: [],
});
